module.exports = __webpack_public_path__ + "img/img02.532ed2b1.png";